import React from 'react'
import './GamesSection.css'
import { Link } from 'react-router-dom'

const GamesSection = () => {
  const games = [
    {
      id: 11,
      title: 'Guess Their Answer',
      platforms: 'Android, iOS',
      info: '100M+ downloads',
      image: '/assets/images/games/guess-their-answer.jpg',
      icon: '/assets/images/icons/guess-their-answer.jpg',
      link: 'https://play.google.com/store/apps/details?id=com.qoni.guesstheiranswer'
    },
    {
      id: 8,
      title: 'Fall Golf',
      platforms: 'Fortnite',
      info: '1M+ players',
      image: '/assets/images/games/fall-golf.jpg',
      link: 'https://www.fortnite.com/@loomio/4373-9217-8383'
    },
    {
      id: 18,
      title: 'Hangman Go!',
      platforms: 'Android, iOS',
      image: '/assets/images/games/hangman-go.jpg',
      icon: '/assets/images/icons/hangman-go.jpg',
      link: 'https://play.google.com/store/apps/details?id=com.loomio.hangmango'
    }
  ]

  return (
    <section className="games-section pattern-bg">
      <div className="container">
        <div className="section-header">
          <h2>Discover our games</h2>
          <Link to="/games" className="btn btn-light">
            See All games
          </Link>
        </div>
        <div className="games-grid">
          {games.map((game) => (
            <a key={game.id} target="_blank" href={game.link} className="game-card">
              <img src={game.image} alt={game.title} className="game-image" />
              {game.icon && (
                <div className="game-icon-overlay">
                  <img src={game.icon} alt={game.title} />
                </div>
              )}
              <div className="game-overlay">
                <div className="game-content">
                  <h3>{game.title}</h3>
                  <div className="game-meta">
                    <span>{game.platforms}</span>
                    <span>{game.info}</span>
                  </div>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  )
}

export default GamesSection
